 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","1":"default~pages-coa-case-list-coa-case-list-module-ngfactory~pages-default-settings-settings-module-ng~ec1553bc","2":"default~pages-default-settings-settings-module-ngfactory~public-download-files-download-files-module~fd5daeab","3":"default~type0-pages-t0-case-t0-case-module-ngfactory~type0-pages-t0-contractor-t0-contractor-module-~ee7f8b72","4":"default~type0-pages-t0-case-t0-case-module-ngfactory~type0-pages-t0-customers-t0-customers-module-ng~1ece5105","5":"default~type0-pages-t0-case-t0-case-module-ngfactory~type1-pages-t1-case-t1-case-module-ngfactory~ty~99074852","6":"default~type0-pages-t0-analytics-t0-analytics-module-ngfactory~type1-pages-t1-analytics-t1-analytics~24706ad9","7":"default~type0-pages-t0-case-t0-case-module-ngfactory~type1-pages-t1-case-t1-case-module-ngfactory","9":"auth-auth-module-ngfactory","11":"pages-_base-base-halodoktor-analytics-base-halodoktor-analytics-module-ngfactory","12":"pages-coa-case-list-coa-case-list-module-ngfactory","13":"pages-coa-customer-coa-customer-module-ngfactory","14":"pages-coa-login-coa-login-module-ngfactory","15":"pages-default-analytics-analytics-module-ngfactory","16":"pages-default-not-found-not-found-module-ngfactory","17":"pages-default-settings-settings-module-ngfactory","18":"pages-home-index-index-module-ngfactory","20":"public-download-files-download-files-module-ngfactory","21":"public-public-logout-public-logout-module-ngfactory","22":"public-renew-pwd-renew-pwd-module-ngfactory","23":"type0-pages-t0-analytics-t0-analytics-module-ngfactory","24":"type0-pages-t0-case-t0-case-module-ngfactory","25":"type0-pages-t0-contractor-t0-contractor-module-ngfactory","26":"type0-pages-t0-customers-t0-customers-module-ngfactory","27":"type0-pages-t0-tasks-t0-tasks-module-ngfactory","28":"type1-pages-t1-analytics-t1-analytics-module-ngfactory","29":"type1-pages-t1-case-t1-case-module-ngfactory","30":"type1-pages-t1-contractor-t1-contractor-module-ngfactory","31":"type1-pages-t1-customers-t1-customers-module-ngfactory","32":"type1-pages-t1-tasks-t1-tasks-module-ngfactory"}[chunkId]||chunkId) + "-es5." + {"0":"94171a211627d81460d4","1":"a8fc567b4d2f54290652","2":"ce38bf9fa9fb3280792a","3":"902f7e3bf3e379bf7f81","4":"31d4be7eb40c89d3d6fc","5":"cffca2814ca4a42cb861","6":"332969108ff89c16de6b","7":"785a958ed4c239442695","9":"35a6e843fc8026165f0e","11":"8bb611b7aeaa404c56aa","12":"4d792560f94d3c678480","13":"5c3f50a647afe7cf5b8e","14":"7621e830c54efc7dba92","15":"c00de7bd4c8ada21ca75","16":"2866f2d00ac084d392b5","17":"4bf1841852775f158c86","18":"8363126a0b68cb5e3d5c","20":"fc461e1ba13bb3de5d5d","21":"f41a1955698c62cfeec4","22":"69309f459958462d58d1","23":"0404699d69f29316894f","24":"636e6d7a5ae6f62074a8","25":"6c04a5dca7da19eabaf6","26":"a86350f728c04ef5de40","27":"13e92d3b0888b9503fdc","28":"5ac74638c61a10500d72","29":"5d5ff6d6ecb050b2a9a7","30":"488409deb219413b5c74","31":"39ba2f1ac9eaa34c854f","32":"ee1e1ddf3fd950aa7ffb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
